module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Visualizar Integrante'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nome",
      "value": _vm.integrante.nome,
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Vínculo",
      "value": _vm.integrante.vinculo,
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Função",
      "value": _vm.integrante.funcao ? _vm.integrante.funcao.descricao : '-'
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Assessor",
      "value": _vm.formatAssessor.format(_vm.integrante.assessor, _vm.integrante.funcao.item)
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Carga horária semanal",
      "value": _vm.integrante.cargaHoraria,
      "align": "justify"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Escolaridade",
      "value": _vm.integrante.titulacao ? _vm.integrante.titulacao.descricao : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Data inicial",
      "value": _vm.integrante.dataInicial ? _vm.dates.format(_vm.integrante.dataInicial) || '-' : '-'
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (this.integrante.situacao !== 'A') ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Data final",
      "value": _vm.integrante.dataFinal ? _vm.dates.format(_vm.integrante.dataFinal) || '-' : '-'
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), ((_vm.integrante.vinculo === 'Externo' || _vm.integrante.vinculo === 'Aluno de pós-graduação')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', [_c('c-readonly-field', {
    attrs: {
      "label": "Instituição que o membro da equipe representa",
      "value": _vm.integrante.instituicao || '-',
      "align": "justify"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', [_c('c-readonly-field', {
    attrs: {
      "label": "Observação",
      "value": _vm.integrante.obsParticipante || '-',
      "align": "justify"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Voltar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33284ba6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/integrantes/visualizar-integrante.vue
// module id = 569
// module chunks = 0